var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDevices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83333 2.50001C5.37309 2.50001 5 2.87311 5 3.33334V16.6667C5 17.1269 5.37309 17.5 5.83333 17.5H14.1667C14.6269 17.5 15 17.1269 15 16.6667V3.33334C15 2.87311 14.6269 2.50001 14.1667 2.50001H5.83333ZM3.33333 3.33334C3.33333 1.95263 4.45262 0.833344 5.83333 0.833344H14.1667C15.5474 0.833344 16.6667 1.95263 16.6667 3.33334V16.6667C16.6667 18.0474 15.5474 19.1667 14.1667 19.1667H5.83333C4.45262 19.1667 3.33333 18.0474 3.33333 16.6667V3.33334Z",
    fill: "#D4C8FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16667 15C9.16667 14.5398 9.53976 14.1667 10 14.1667H10.0083C10.4686 14.1667 10.8417 14.5398 10.8417 15C10.8417 15.4602 10.4686 15.8333 10.0083 15.8333H10C9.53976 15.8333 9.16667 15.4602 9.16667 15Z",
    fill: "#D4C8FA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.98b82f8c.svg";
export { ForwardRef as ReactComponent };